module.exports = __webpack_public_path__ + "img/Gardien.be592465.png";